<template>
  <div class="tc-checkbox-group">
    <el-checkbox-group @change="handleChange" v-model="changeValue" v-bind="{ ...item }">
      <template v-for="(option, i) in item.config.options">
        <div
          v-if="!isHideQuota(option)"
          :key="option.value"
          class="show-vote"
          :class="[
            item.config.inline ? 'inline-block' : 'block',
            isChecked(option.value) ? 'checked' : '',
            item.disabled ? 'disabled' : '',
            isBorder(i) ? 'has-border' : '',
            curSelectedOption === option.value ? 'highWeight' : ''
          ]"
        >
          <div class="drawing-list picture" v-if="mode === 'design'">
            <upload-img
              :key="'picture' + option.value"
              :show-file-list="false"
              listType="text"
              :limitCount="100"
              @uploadSuccess="(res) => uploadLogoHandle(res, i)"
            >
              <template slot="btn">
                <span class="drawing-item__picture">
                  <i class="el-icon-picture-outline" />
                </span>
              </template>
            </upload-img>
          </div>
          <t-checkbox
            :label="option.value"
            :disabled="option.quotaSetting && getSurplusQuota(option) <= 0"
            :mode="mode"
          >
            <span v-if="getSurplusQuota(option) <= 0 && item.config.quotaBlankWarning">{{
              item.config.quotaBlankWarning
            }}</span>
            <span v-else>{{ option.label }}</span>
            <span class="text-muted" v-if="showQuota(option)">(余{{ getSurplusQuota(option) }})</span>
          </t-checkbox>

          <div class="option_desc_input" v-if="mode === 'design' || option.description">
            <el-input v-if="mode === 'design'" v-model="option.description" placeholder="选项描述" />
            <span v-else-if="option.description" class="option_desc">{{ option.description }}</span>
          </div>

          <div class="vote-wrap">
            <template v-if="option.isFill && isChecked(option.value)">
              <div class="extension_box">
                <span v-if="option.required" class="required_icon"></span>
                <el-form-item
                  class="extension_item"
                  :prop="`${item.vModel}extension_${option.value}`"
                  label=""
                  :rules="{
                    required: option.required && item.isFieldShow,
                    message: '选项后内容为必填项',
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-select
                    v-model="option.inputValue"
                    @change="(val) => optionExtensionChange(val, option.value)"
                    v-if="option.fillContent"
                    style="width: 100%"
                    :popper-append-to-body="false"
                    @focus="selectFocus(option.value)"
                  >
                    <el-option
                      :value="opt.label"
                      v-for="opt in option.fillContentJson"
                      :key="opt.value"
                      :label="opt.label"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-else
                    v-model="option.inputValue"
                    class="other-input"
                    @input="(val) => optionExtensionChange(val, option.value)"
                  />
                </el-form-item>
              </div>
            </template>
            <template v-if="option.optionImgUrl">
              <upload-img
                v-if="mode === 'design'"
                :alreadyFile="option.optionImgUrl"
                listType="picture-card"
                @removeSuccess="removeBgImgHandle(i)"
              >
              </upload-img>
              <el-image
                v-else
                :preview-src-list="[option.optionImgUrl]"
                :src="option.optionImgUrl"
                class="image"
                fit="contain"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>
            </template>
            <vote
              :value="option.value"
              :vote-list="voteList"
              :total-vote="totalVote"
              v-if="item.config.showVoteResult"
            />
          </div>
        </div>
      </template>
      <!--      <template v-else>
              <template v-for="option in item.config.options">
                <el-checkbox-button
                  v-if="!isHideQuota(option)"
                  :key="option.value"
                  :label="option.value"
                  :style="{
                    display: item['config'].inline ? 'inline-block' : 'block',
                  }"
                >
                  <span v-if="option.quota <= 0 && item.config.quotaBlankWarning">{{
                    item.config.quotaBlankWarning
                  }}</span>
                  <span v-else>{{ option.label }}</span>
                  <span class="text-base-color" v-if="showQuota(option)"
                    >(余{{ option.quota }})</span
                  >
                </el-checkbox-button>
              </template>
            </template>-->
    </el-checkbox-group>
  </div>
</template>

<script>
import Vote from '../TVote/vote'
import mixin from '../mixin'
import VoteMixin from '../TVote/VoteMixin'
import TCheckbox from './TCheckbox'
import optionQuotaMixin from '../mixins/OptionQuotaMixin'
import UploadImg from '@/components/Upload/UploadImg.vue'

export default {
  name: 'TCheckboxGroup',
  mixins: [mixin, VoteMixin, optionQuotaMixin],
  components: {
    Vote,
    TCheckbox,
    UploadImg
  },
  props: ['models'],
  data() {
    return {
      otherInputValue: ''
    }
  },
  computed: {},
  // watch: {
  //   otherInputValue: {
  //     deep: true,
  //     handler(val) {
  //       this.models[`${this.item.vModel}${this.changeValue === 0 ? 'other' : 'extension_' + this.changeValue}`] = val
  //       this.$emit('other-input-change', this.changeValue, this.item)
  //     }
  //   }
  // },
  mounted() {
    if (this.models) {
      this.otherInputValue = this.models[`${this.item.vModel}other`]
    }
  },
  methods: {
    isChecked(val) {
      const { changeValue } = this
      return changeValue && changeValue.indexOf(val) > -1
    },
    isBorder(i) {
      const len = this.item.config.options.length
      const _i = i + 1
      // 被2整除 那么 最后两个不需要border
      if (len % 2 == 0) {
        return _i != len && _i != len - 1
      } else {
        // 不能被2整除 那么 最一个不需要border
        return _i !== len
      }
    },
    handleChange(val) {
      if (this.item.disabled) {
        return
      }

      if (!val.length) {
        return
      }

      this.handleArrayVote(this.value)

      const { exclusiveChoiceApiCodes, withExclusiveChoice } = this.item.config

      if (withExclusiveChoice) {
        // 变化的值
        const changeVal = val[val.length - 1]

        // 选中还是取消
        const isChecked = val.findIndex((e) => e.toString() === changeVal.toString())

        // 是否是互斥
        const isExclusive = exclusiveChoiceApiCodes.findIndex((e) => e.toString() === changeVal.toString())

        // 选中 并且 互斥
        if (isChecked > -1 && isExclusive > -1) {
          this.$emit('input', [changeVal])
        }

        // 选中 并且 不互斥
        if (isChecked > -1 && isExclusive === -1) {
          // 不是互斥的值
          const noExclusive = val.filter((e) => {
            const index = exclusiveChoiceApiCodes.findIndex((ex) => ex.toString() === e.toString())
            return index < 0
          })
          this.$emit('input', noExclusive)
        }
      }
    }
    // uploadLogoHandle(response, index) {
    //   const _config = this.item.config
    //   _config.options[index].optionImgUrl = response[response.length - 1].url
    //   this.$emit('upload-option-img', _config)
    // },
    // removeBgImgHandle(index) {
    //   const _config = this.item.config
    //   _config.options[index].optionImgUrl = ''
    //   this.$emit('upload-option-img', _config)
    // },
    // selectFocus(value) {
    //   this.curSelectedOption = value
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/form/home.scss';
.tc-checkbox-group .el-checkbox {
  height: auto;
  padding: 5px 10px 0;
  line-height: 16px !important;
}

::v-deep .el-checkbox {
  display: flex;

  .el-checkbox__input {
    line-height: 20px !important;
  }

  .el-checkbox__label {
    font-size: 16px;
    line-height: 16px !important;
  }
}

.block {
  // margin-bottom: 10px;
  border-bottom: 1px solid #dcdfe6;

  .el-checkbox {
    width: 100%;
  }

  .other-input {
    margin-top: 10px;
  }
}
.el-checkbox-group {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
}

.inline-block {
  display: inline-block;
  // margin-bottom: 10px;
  // margin-right: 10px;
  vertical-align: top;

  .el-checkbox {
    width: 100%;
  }

  .other-input {
    margin-top: 10px;
  }
}

.inline-block.show-vote {
  min-width: 50%;
}
.inline-block.show-vote.has-border {
  border-bottom: 1px solid #dcdfe6;
}

.show-vote {
  padding: 10px 0;
  color: #979797;
  position: relative;
  .other-input {
    margin-top: 0;
  }
  .picture {
    top: 10px;
    .drawing-item__picture {
      display: inline-block;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
      color: #1890ff;
    }
  }
}
.block[class~='show-vote']:last-of-type {
  border: none;
}

@media screen and (max-width: 414px) {
  .inline-block.show-vote:nth-child(even) {
    margin-right: 0;
  }
}

.show-vote {
  // border-radius: 8px;
  // border: 1px solid #dcdfe6;

  .vote-wrap {
    padding: 5px 10px;
    position: relative;
  }

  .vote-wrap:empty {
    padding: 0;
  }
  .extension_box {
    display: flex;
    .required_icon {
      margin-right: 4px;
      font-size: 12px;
      &::before {
        content: '*';
        color: #f56c6c;
      }
    }
    .extension_item {
      flex-shrink: 0;
      width: 90%;

      .option-content {
        padding-right: 12px;
      }
    }
  }
  .image {
    width: 130px;
    height: 130px;
  }
}

.checked {
  border-color: #1890ff;
}

.checked.disabled {
  border-color: #dcdfe6;
}

::v-deep {
  .el-checkbox__label {
    width: 90% !important;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    display: inline-block;
    vertical-align: middle;
  }
  .option_desc_input {
    min-height: 18px;
    line-height: 1;
    margin-bottom: 5px;
    .el-input__inner,
    .option_desc {
      width: 90%;
      color: #938d8d;
      border: none;
      background: transparent;
      padding: 0px 0 0 34px;
      position: relative;
      z-index: 1;
      font-size: 16px;
      font-weight: normal;
      line-height: 1;
      opacity: 0.7;
      display: inline-block;
      word-break: break-all;
    }
  }
}
</style>
